import React, { useState, useCallback, useMemo } from 'react';

import Dropdown, { VirtualizedMenu } from '@adsk/alloy-react-dropdown';
import Portal from '@adsk/alloy-react-portal';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import { getFilteredItems, renderDropdownMenuItem } from '../helpers/utils';

const AccordionSelectBox = ({
  items: itemsProp,
  selectedItem,
  placeholder: placeholderProp,
  setSelectedItem,
}) => {
  const [inputValue, setInputValue] = useState('');
  const [placeholder, setPlaceholder] = useState(placeholderProp);

  const onInputValueChange = useCallback(
    ({ inputValue }) => setInputValue(inputValue),
    [],
  );

  const onIsOpenChange = useCallback(
    ({ isOpen, selectedItem }) => {
      setPlaceholder(isOpen ? null : placeholderProp);
      if (!isOpen && !selectedItem) {
        setInputValue('');
      }
    },
    [placeholderProp],
  );

  const onSelectedItemChange = useCallback(
    ({ selectedItem }) => {
      setSelectedItem(selectedItem);
    },
    [setSelectedItem],
  );

  const items = useMemo(
    () =>
      itemsProp.map(({ label, ...rest }) => ({
        label: (
          <OverflowTooltip
            getTargetProps={() => ({
              style: { maxWidth: 'calc(100% - 32px)' },
            })}
          >
            {label}
          </OverflowTooltip>
        ),
        ...rest,
      })),
    [itemsProp],
  );

  const renderMenuItem = (itemProps) =>
    renderDropdownMenuItem(itemProps, inputValue);

  return (
    <Dropdown
      isAutocomplete
      allowCollapsibleGroups
      style={{ width: '100%' }}
      placeholder={placeholder}
      inputValue={inputValue}
      items={items}
      selectedItem={selectedItem}
      getFilteredItems={getFilteredItems}
      renderMenu={(menuProps, virtualProps) => (
        <Portal container={document.body}>
          {VirtualizedMenu.render(
            {
              ...menuProps,
              renderMenuItem,
              ...(!selectedItem && { renderFooter: () => null }),
            },
            virtualProps,
          )}
        </Portal>
      )}
      onInputValueChange={onInputValueChange}
      onIsOpenChange={onIsOpenChange}
      onSelectedItemChange={onSelectedItemChange}
    />
  );
};

export default AccordionSelectBox;
